export const VALIDATE_TERMS = 'termsOfUse/VALIDATE_TERMS_OF_USE';
export const UPDATE_TERMS = 'termsOfUse/UPDATE_TERMS_OF_USE';
